export default {
  order_methods: {
    delivery: 'Lieferung',
    pickup: 'Abholung',
    room_service: 'Vor Ort',
    table_service: 'Vor Ort',
  },
  time: '{{time}} min',
  asap: 'ASAP',
  unavailable: 'Nicht verfügbar',
  ready_in: 'Bereit in ',
  buttons: {
    change: 'Ändern',
    see_hours: 'Öffnungszeiten',
    change_location: 'Standort ändern',
    change_time: 'Zeit ändern',
  },
};
